<script>
import { mapState } from "vuex";

export default {
  props: {
    speed: { type: Number, default: 1.0 },
    
    // will not move element on page load,
    // good if element is placed in the top of page
    clamp: { type: Boolean, default: false }
  },

  data() {
    return {
      accualSpeed: (this.speed - 1) * -1,
      placementInPage: 0
    };
  },

  computed: {
    ...mapState({
      currentScroll: state => state.globals.currentScroll,
      screenHeight: state => state.globals.screenHeight,
      screenWidth: state => state.globals.screenWidth
    }),

    translateValue() {
      return this.clamp
        ? this.currentScroll * this.accualSpeed
        : (this.currentScroll + this.screenHeight / 2 - this.placementInPage) *
            this.accualSpeed;
    },

    translate() {
      if (this.$el) {
        Object.assign(this.$el.style, {
          transform: `translate3d(0, ${this.translateValue}px, 0)`
        });
      }

      return this.translateValue; // NOTE: for some reason this has to be here..
    }
  },

  watch: {
    screenWidth: "normalizeCenter",
    currentScroll: "normalizeCenter"
  },

  render() {
    return this.$scopedSlots.default({
      // not in use, but doesn't work without it..?
      translate: this.translate
    });
  },

  methods: {
    normalizeCenter() {
      this.placementInPage =
        this.currentScroll + this.topBorderOffset() + this.halfElementHeight();
    },
    topBorderOffset() {
      return parseInt(this.$el.getBoundingClientRect().top);
    },
    halfElementHeight() {
      return parseInt(this.$el.getBoundingClientRect().height) / 2;
    }
  },

  mounted() {
    if (this.$el.querySelector('img')) {
      this.$el.querySelector('img').addEventListener("load", this.normalizeCenter.bind(this));
    } else {
      this.$nextTick(() => this.normalizeCenter());
    }
  }
};
</script>